import { buildODataQuery } from "@sg-protect/core";
import { queryOptions } from "../../client.ts";
import type { ODataSiteCollectionODataCollectionResponse, ODataUserODataCollectionResponse } from "../../types.ts";

export function siteCollectionDetailsQueryOptions(id: string) {
    const query = buildODataQuery({
        select: [
            "id",
            "displayName",
            "description",
            "webUrl",
            "types",
            "sharingCapability",
            "contentSizeInBytes",
            "sharePointLastActivity",
            "restrictedAccessControl",
            "restrictedContentDiscovery",
            "storageQuotaTotalBytes",
            "versionStorageBytes",
            "versionStorageQuotaPercent",
            "versionStorageSitePercent",
            "fileCount",
            "largeFileCount",
            "inactiveFileCount",
            "oldFileCount",
            "versionLimit",
            "majorVersionLimit",
            "enableAutoExpirationVersionTrim",
            "expireVersionsAfterDays"
        ],
        filter: `id eq ${id}`,
        expand: ["sensitivityLabel($select=name)"],
        top: 1
    });

    return queryOptions(
        "get",
        "/bff/odata/siteCollections",
        { params: { query } },
        { select: (data: ODataSiteCollectionODataCollectionResponse) => data.value?.[0] }
    );
}

export function userDetailsQueryOptions(id: string) {
    const query = buildODataQuery({
        select: [
            "id",
            "userPrincipalName",
            "displayName",
            "email",
            "jobTitle",
            "department",
            "type",
            "isEnabled",
            "isEligibleForOneDrive",
            "lastSignInDate"
        ],
        filter: `id eq ${id}`,
        top: 1
    });

    return queryOptions(
        "get",
        "/bff/odata/users",
        { params: { query } },
        { select: (data: ODataUserODataCollectionResponse) => data.value?.[0] }
    );
}
